import { Link } from "@tanstack/react-router";
import { Eye, Pencil } from "lucide-react";
import type { Ticket } from "../../types/ticket.types";
import { ROUTES } from "../constants";

export function TicketReferenceCell({ ticket }: { ticket: Ticket }) {
  // id is a UUID (36 chars) — show a short stable prefix.
  const ref = `TK-${String(ticket.id).slice(0, 8).toUpperCase()}`;
  return <span className="font-mono text-[11px] text-[var(--ink-soft)]">{ref}</span>;
}

export function TicketTitleCell({ ticket, cellText }: { ticket: Ticket; cellText: string }) {
  return (
    <Link
      to={ROUTES.TICKETS.VIEW}
      params={{ id: String(ticket.id) }}
      className={`font-semibold truncate hover:underline ${cellText}`}
    >
      {ticket.title}
    </Link>
  );
}

export function TicketActionsCell({ ticket, iconClass }: { ticket: Ticket; iconClass: string }) {
  return (
    <div className="flex items-center gap-0.5">
      <div className="tooltip tooltip-top" data-tip="Voir">
        <Link
          to={ROUTES.TICKETS.VIEW}
          params={{ id: String(ticket.id) }}
          className="btn btn-ghost btn-xs rounded-md"
        >
          <Eye className={iconClass} />
        </Link>
      </div>
      <div className="tooltip tooltip-top" data-tip="Modifier">
        <Link
          to={ROUTES.TICKETS.EDIT}
          params={{ id: String(ticket.id) }}
          className="btn btn-ghost btn-xs rounded-md text-warning"
        >
          <Pencil className={iconClass} />
        </Link>
      </div>
    </div>
  );
}
